'use strict';

angular.module('mediacloudApp')
    .controller('LoginController', function ($rootScope, $scope, $location, $window, $state, $timeout, Auth, Tenant) {
        $scope.user = {};
        $scope.errors = {};
        $rootScope.hideHeaderAndFooter = false;
        Tenant.info().then(function (tenant) {
            $scope.tenant = tenant;
        });

        if($rootScope.sessionTimeout){
            $scope.sessionTimeoutError = true;
        }

        if($rootScope.lmsSessionTimeout){
            $scope.lmsSessionTimeoutError = true;
        }

        $scope.rememberMe = true;

        $timeout(function (){angular.element('[ng-model="username"]').focus();});

        $scope.login = function (event) {
            event.preventDefault();
            Auth.login({
                username: $scope.username,
                password: $scope.password,
                rememberMe: $scope.rememberMe
            }).then(function () {
                $scope.authenticationError = false;
                $rootScope.sessionTimeout = false;
                $rootScope.$broadcast('loggedIn');
                if($rootScope.nextState){
                    var nextStateName = $rootScope.nextState.name,
                        nextStateParams = $rootScope.nextState.params;
                    if(nextStateName === 'protected'){
                        $state.go('protected', {type: nextStateParams.type, collectionId: nextStateParams.collectionId})
                    } else if(nextStateName === 'playback'){
                        $state.go('playback', {collectionType: nextStateParams.collectionType, collectionId: nextStateParams.collectionId, assetId: nextStateParams.assetId})
                    }
                    $rootScope.nextState = null;
                } else {
                    $rootScope.back();
                }
            }).catch(function () {
                $scope.authenticationError = true;
            });
        };

        $scope.samlLogin = function(){
            $window.location.href = './saml/login';
        };
    });
